import React from 'react'

const DashboardCard = (props) => {
  return (
    <div className="p-5 bg-white rounded-lg shadow">
        <div className="flex items-center justify-between">
            <div className={`p-3 ${props.color} rounded-lg`}>
                <props.icon className="w-10 h-10 text-white" />
            </div>
            <div className="text-4xl font-semibold">{props.value}</div>
        </div>
        <div className="text-right">{props.label}</div>
    </div>
  )
}

export default DashboardCard